import { useState } from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import Layout from "./Layout/Layout";
import Login from "./Pages/Login/login";
import Public from "./Pages/Public";
import { ConfigProvider } from "antd";
import ptPT from "antd/lib/locale/pt_PT";
import "./laravel-echo";
import { useLocation } from "react-router-dom";

export default function App({ children, header }: any) {
  const queryClient = new QueryClient();
  const userStorage = localStorage.getItem("user") || null;
  const [user] = useState(userStorage ? JSON.parse(userStorage) : null);

  const location = useLocation();
  const pathname = location.pathname;

  return (
    <ConfigProvider
      locale={ptPT}
      theme={{
        token: {
          colorPrimary: "#0899d1",
          colorBgLayout: "#ebf3f5",
        },
        components: {
          Button: {
            colorPrimary: "#0899d1",
            colorLink: "#0899d1",
          },
          Menu: {
            itemSelectedBg: "#dfe6e8",
            itemSelectedColor: "#252626",
            itemHoverColor: "#0899d1",
            itemColor: "#252626",
          },
          Select: {
            controlItemBgActive: "#d1fdff",
          },
        },
      }}
    >
      <QueryClientProvider client={queryClient}>
        {pathname.indexOf("invoices/") > -1 ||
        (pathname.indexOf("plans/") > -1 &&
          pathname.indexOf("management/plans/") === -1) ? (
          <Public />
        ) : !user ? (
          <Login />
        ) : (
          <Layout />
        )}
      </QueryClientProvider>
    </ConfigProvider>
  );
}
